(function () {
    if (!document.body.classList.contains('post-template')) {
        return;
    }

    const shares = document.querySelectorAll('.rv-post-share');

    if (!shares.length) {
        return;
    }

    function copyText(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }

        return new Promise((resolve, reject) => {
            const input = document.createElement('textarea');
            input.value = text;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();

            try {
                document.execCommand('copy');
                document.body.removeChild(input);
                resolve();
            } catch (error) {
                document.body.removeChild(input);
                reject(error);
            }
        });
    }

    function buildShareUrl(network, url, title) {
        const shareUrl = encodeURIComponent(url);
        const shareTitle = encodeURIComponent(title);

        switch (network) {
        case 'facebook':
            return `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
        case 'twitter':
            return `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`;
        case 'linkedin':
            return `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`;
        default:
            return '#';
        }
    }

    function openShareWindow(url) {
        const popup = window.open(url, '_blank', 'noopener,noreferrer');

        if (popup) {
            popup.focus();
        }
    }

    shares.forEach((share) => {
        if (share.dataset.shareReady === 'true') {
            return;
        }

        share.dataset.shareReady = 'true';

        const url = share.dataset.shareUrl || window.location.href;
        const title = share.dataset.shareTitle || document.title;

        share.querySelectorAll('[data-share-network]').forEach((link) => {
            const network = link.dataset.shareNetwork;
            const shareUrl = buildShareUrl(network, url, title);

            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                openShareWindow(shareUrl);
            });
        });

        const copyButton = share.querySelector('[data-share-copy]');
        const copyLabel = share.querySelector('[data-share-copy-label]');

        if (!copyButton || !copyLabel) {
            return;
        }

        let copiedTimeout = null;

        copyButton.addEventListener('click', async () => {
            try {
                await copyText(url);
                copyButton.classList.add('is-copied');
                copyLabel.textContent = 'Copied';

                window.clearTimeout(copiedTimeout);
                copiedTimeout = window.setTimeout(() => {
                    copyButton.classList.remove('is-copied');
                    copyLabel.textContent = 'Copy link';
                }, 2200);
            } catch (error) {
                copyLabel.textContent = 'Copy failed';

                window.clearTimeout(copiedTimeout);
                copiedTimeout = window.setTimeout(() => {
                    copyLabel.textContent = 'Copy link';
                }, 2200);
            }
        });
    });
})();
